import { useState } from 'react';

const FloatingInput = ({
    id,
    label,
    value,
    onChange,
    type = 'text',
    required = false,
    error,
    darkMode,
    small = false,
    name,
    disabled = false,
    readOnly = false,
    min,
    max,
    placeholder,
    maxLength,
    step,
    inputMode,
    pattern,
    onBlur,
    ...rest
}) => {
    const [isFocused, setIsFocused] = useState(false);

    // Determine if the label should be in the "floating" state (top) or inside the input
    const isLabelFloating = isFocused || value;

    return (
        <div className="relative mb-4 w-full min-w-0">
            <input
                id={id}
                name={name || id}
                type={type}
                value={value}
                onChange={onChange}
                onFocus={() => setIsFocused(true)}
                onBlur={(e) => {
                    onBlur?.(e);
                    setIsFocused(false);
                }}
                required={required}
                disabled={disabled}
                readOnly={readOnly}
                min={min}
                max={max}
                placeholder={placeholder}
                maxLength={maxLength}
                step={step}
                inputMode={inputMode}
                pattern={pattern}
                className={`block w-full rounded-none border-0 border-b px-3 py-3.5 text-sm text-left placeholder:text-transparent
                    ${error ? 'border-b border-red-500' : isFocused ? 'border-b border-redhalo-red' : 'border-b border-gray-300'}
                    focus:outline-none focus:ring-0
                    ${!error && !disabled && !readOnly ? 'hover:border-b-redhalo-navy' : ''}
                    ${disabled ? 'cursor-not-allowed bg-white text-gray-500 disabled:bg-white' : 'bg-white text-gray-900'}`}
                {...rest}
            />
            <label
                htmlFor={id}
                className={`absolute text-sm 
                    ${error ? 'text-red-500' : isFocused ? 'text-redhalo-navy' : 'text-gray-600'}
                    duration-300 transform 
                    ${'-translate-y-4 scale-75' }
                    top-2 z-10 origin-[0]
                    ${'bg-white'} px-2 left-1 rounded-none`}
            >
                {label}
                {required && <span className="text-red-500"> *</span>}
            </label>
            {error ? (
                <p className="mt-0.5 text-xs text-red-500" aria-live="polite">
                    {error}
                </p>
            ) : null}
        </div>
    );
};

export default FloatingInput;